import React from 'react';
import { SignIn, SignUp } from '@clerk/clerk-react';
import { Link, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { TendTextLogo } from './ui/TendLogo';
import '../landing/landing.css';

/** Clerk, dressed in the landing page's material: moss primary, Funnel Sans, quiet hairlines. */
const appearance = {
  variables: {
    colorPrimary: '#4a5d23', colorText: '#1b1d21', colorTextSecondary: '#5b5f66', colorBackground: '#ffffff',
    colorInputBackground: '#ffffff', colorInputText: '#1b1d21', borderRadius: '12px',
    fontFamily: '"Funnel Sans", ui-sans-serif, system-ui, sans-serif', fontSize: '15px',
  },
  elements: {
    rootBox: { width: '100%' },
    cardBox: { width: '100%', boxShadow: 'none', border: '1px solid rgba(27,29,33,0.08)', borderRadius: '16px' },
    card: { boxShadow: 'none' },
    header: { display: 'none' },
    logoBox: { display: 'none' },
    formButtonPrimary: { borderRadius: '10px', minHeight: '44px', fontWeight: 500, textTransform: 'none', background: '#4a5d23', backgroundImage: 'none', boxShadow: 'none', '&:hover': { background: '#3f4f1d' }, '&::after': { display: 'none' } },
    socialButtonsBlockButton: { borderRadius: '10px', minHeight: '44px' },
  },
};

const AuthScreen = ({ mode = 'signin' }) => {
  const location = useLocation();
  const isSignUp = mode === 'signup' || location.pathname === '/signup';
  const next = (() => { try { const p = sessionStorage.getItem('tend.afterAuth') || ''; return p.startsWith('/app') ? p : '/app'; } catch { return '/app'; } })();
  const firstHabit = (() => { try { return localStorage.getItem('tend.firstHabit') || ''; } catch { return ''; } })();
  return (
    <div className="lp lp-auth">
      <Helmet>
        <title>{isSignUp ? 'Start free' : 'Sign in'} | Tend</title>
        <meta name="robots" content="noindex, nofollow" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link href="https://fonts.googleapis.com/css2?family=Funnel+Display:wght@400&family=Funnel+Sans:wght@400;500&display=swap" rel="stylesheet" />
      </Helmet>
      <section className="lp-auth__side" aria-hidden="true">
        <figure className="lp-screen"><img src="/landing/today.jpg" alt="" width="780" height="1688" /></figure>
      </section>
      <main className="lp-auth__main">
        <Link to="/" className="lp-auth__mark" aria-label="Tend home"><TendTextLogo className="h-[22px]" color="currentColor" /></Link>
        <div className="lp-auth__form">
          <h1 className="lp-auth__title">{isSignUp ? 'Start with one small habit' : 'Sign in to Tend'}</h1>
          <p className="lp-auth__sub">{isSignUp ? (firstHabit ? <>Your first habit: {firstHabit}. Free to start, no card needed.</> : 'Free to start. No card needed.') : 'Your day is where you left it.'}</p>
          {isSignUp
            ? <SignUp fallbackRedirectUrl={next} signInUrl="/login" appearance={appearance} />
            : <SignIn fallbackRedirectUrl={next} signUpUrl="/signup" appearance={appearance} />}
        </div>
        <p className="lp-auth__legal">By continuing you agree to the <Link to="/terms">terms</Link> and <Link to="/privacy">privacy policy</Link>.</p>
      </main>
    </div>
  );
};

export default AuthScreen;
